import './FormField.css';

/* ─────────────────────────────────────────────────────────────
   FORM FIELD — Wraps a label, an input, and an error message
   into a single composable unit.

   Props:
   - label:    the visible label text
   - htmlFor:  must match the id of the Input inside — connects
               the label to the input for accessibility
   - error:    error message string — shown in red below the input
   - children: the Input component (or any form element)

   Example usage:
   <FormField label="Email address" htmlFor="email" error={errors.email}>
     <Input id="email" type="email" value={email} onChange={...} />
   </FormField>
   ───────────────────────────────────────────────────────────── */
function FormField({ label, htmlFor, error, children }) {
  return (
    <div className="form-field">
      {label && (
        <label className="form-label" htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {children}
      {error && <p className="form-error">{error}</p>}
    </div>
  );
}

export default FormField;
